<template>
  <div class="interaction-body answered multiple-choice multiple-choice-answered">
    <v-radio-group
      class="pt-0"
      :value="localInteractionAttempt.interactionOptionIds[0]"
      hide-details
    >
      <div
        class="multiple-choice-option mb-1 pa-1 playposit-answer"
        :class="interactionOptionData[idx].answerClass"
        :key="idx"
        v-for="(io, idx) in localInteraction.interactionOptions"
      >
        <v-layout
          align-center
        >
          <v-flex xs12>
            <v-radio
              class="mb-0"
              :value="io.id"
              :ripple="false"
              readonly
              :color="interactionOptionData[idx].answerColor"
              :aria-label="interactionOptionData[idx].ariaLabel"
            >
              <div
                class="mb-0 pp-interaction-body"
                slot="label"
                v-html="io.option"
              ></div>
            </v-radio>
            <InteractionAttachments :attachments="io.interactionOptionAttachments" />
          </v-flex>
        </v-layout>
        <text-box
          v-show="interactionOptionData[idx].showTextBox"
          :color-key="interactionOptionData[idx].textBoxColorKey"
          :show-color-rod="!hideCorrectAnswerAlways"
          :title="interactionOptionData[idx].textBoxTitle"
          :text="io.feedback"
          :show-text="localInteractionAttempt.interactionOptionIds.includes(io.id)"
          tabindex="0"
          :aria-label="`Feedback for answer #${idx + 1}: ${io.feedback && io.feedback.length ? io.feedback.stripHTML(['img', 'Image']) : ''}`"
          :attachments="io.interactionOptionFeedbackAttachments"
          :show-attachments="localInteractionAttempt.interactionOptionIds.includes(io.id)"
          :add-extra-space-above="!io.interactionOptionAttachments.length"
        ></text-box>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'MultipleChoiceAnsweredInteractionBody',
  components: {
    InteractionAttachments,
    TextBox,
  },
  mixins: [
    Interaction,
  ],
  props: {
    interactionAttempt: {
      type: Object,
      required: true,
    },
  },
  computed: {
    correctAnswer() {
      return this.localInteraction.interactionOptions.find((io) => io.correct).option;
    },
    interactionOptionData() {
      return this.localInteraction.interactionOptions.map((io, idx) => {
        const isSelected = this.localInteractionAttempt.interactionOptionIds.includes(io.id);
        let textBoxTitle;
        if (this.hideCorrectAnswerAlways
        || (
          this.hideCorrectAnswerIfNotSelected
          && (
            io.correct
            && !isSelected
          )
        )) textBoxTitle = 'Feedback';
        else if (io.correct) textBoxTitle = 'Correct';
        else if (this.localInteractionAttempt.responseText === io.option) textBoxTitle = 'Incorrect';
        else textBoxTitle = '';
        return {
          answerClass: (() => {
            if (
              this.hideCorrectAnswerAlways
              || (
                this.hideCorrectAnswerIfNotSelected
                && (
                  io.correct
                  && !isSelected
                )
              )
            ) return '';
            if (io.correct) return 'correct';
            else if (!io.correct && isSelected) return 'incorrect';
            return '';
          })(),
          answerColor: (() => {
            if (this.hideCorrectAnswerAlways) return null;
            return io.correct ? '#4CAF50' : '#F44336';
          })(),
          showTextBox: (() => {
            if (
              this.hideCorrectAnswerAlways
              || (
                this.hideCorrectAnswerIfNotSelected
                && (
                  io.correct
                  && !isSelected
                )
              )
            ) {
              return (
                isSelected
                && io.feedback.length
              );
            }
            return io.correct || isSelected;
          })(),
          textBoxColorKey: (() => {
            if (this.hideCorrectAnswerAlways
            || (
              this.hideCorrectAnswerIfNotSelected
              && (
                io.correct
                && !isSelected
              )
            )) return 'hidden';
            return io.correct ? 'green' : 'red';
          })(),
          textBoxTitle,
          ariaLabel: (() => {
            let label = `Answer #${idx + 1}. Answer status: `;
            label += isSelected ? 'Selected. ' : 'Unselected. ';
            if (
              textBoxTitle.length
              && textBoxTitle !== 'Feedback'
            ) label += `Answer result: ${textBoxTitle}. `;
            label += `Answer value: ${io.sanitizedOption}`;
            return label;
          })(),
        };
      });
    },
  },
};
</script>
